export default __webpack_public_path__ + "static/media/maxresdefault.788bac69.jpg";